var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAccountBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16665 3.99998C8.16665 5.74888 6.74888 7.16665 4.99998 7.16665C3.25108 7.16665 1.83331 5.74888 1.83331 3.99998C1.83331 2.25108 3.25108 0.833313 4.99998 0.833313C6.74888 0.833313 8.16665 2.25108 8.16665 3.99998Z",
    fill: "#5555FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.46603 9.29934C2.4034 8.36196 3.67435 7.83472 5 7.83331C6.32565 7.83472 7.5966 8.36196 8.53398 9.29934C9.47135 10.2367 9.99859 11.5077 10 12.8333C10 12.9217 9.96488 13.0065 9.90237 13.069C9.83986 13.1315 9.75507 13.1666 9.66667 13.1666H0.333333C0.244928 13.1666 0.160143 13.1315 0.0976312 13.069C0.0351191 13.0065 0 12.9217 0 12.8333C0.00141168 11.5077 0.528649 10.2367 1.46603 9.29934Z",
    fill: "#5555FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccountBlue);
export default __webpack_public_path__ + "static/media/UserAccountBlue.a2e46705e33cd8d44574d8910efdc133.svg";
export { ForwardRef as ReactComponent };